var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"outlined":"","multiple":_vm.multiple,"chips":_vm.multiple,"loading":_vm.loading,"label":_vm.label,"hint":_vm.hint,"persistent-hint":"","items":_vm.items,"item-value":"id","item-text":"name","hide-details":"auto","clearable":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }